import {useAPI} from "../../../lib/common";

import EditTemplateProduct from "../Components/EditTemplateProduct/EditTemplateProduct";
import React, {useEffect, useMemo} from "react";
import {useHistory, useRouteMatch} from "react-router";
import {usePriceList} from "../../Providers/PriceListProvider";
import {RecentImagesProvider, useRecentImages} from "../hooks/recentimages";
import TemplateInstanceProvider, {ACTIONS} from "../../Providers/TemplateInstanceProvider";
import useTemplateInstance from "../hooks/useTemplateInstance";

export default () => {
    console.log('Create template product');
    return <TemplateInstanceProvider>
        <RecentImagesProvider>
            <Wrapper />
        </RecentImagesProvider>
    </TemplateInstanceProvider>
}

const Wrapper = () => {
    const match = useRouteMatch();
    const {getProductByUuid} = usePriceList();
    const [state, dispatch] = useTemplateInstance();
    const history = useHistory();

    const [template] = useAPI(`/m/api/templates/by-uuid/${match.params.templateUuid}`)

    const product = useMemo(() => {
        return getProductByUuid(match.params.productUuid);
    }, [match.params.productUuid])

    useEffect(() => {
        if (!template || !product) {
            return;
        }
        console.log('Use effect, template change')
        dispatch({
            type: ACTIONS.SET_TEMPLATE,
            template
        });

        /*
        dispatch({
            type: ACTIONS.FILL_TEMPLATE,
            userImages: recentImages
        });
         */

        dispatch({
            type: ACTIONS.SET_PRODUCT,
            product: product
        })

    }, [template, product]);

    const handleGoBack = (e) => {
        e.stopPropagation();
        const l = document.location.pathname;
        if (l.startsWith('/m/products/calendars/')) {
            history.push('/products/calendars/')
        } else if (l.startsWith('/m/products/cards/')) {
            history.push(`/products/cards/${encodeURIComponent(match.params.category)}`)
        } else if (l.startsWith('/m/products/photogift/')) {
            history.push(`/products/photogift/${encodeURIComponent(match.params.category)}/`)
        }
    }


    if (!template) {
        return <div>Loading</div>
    }

    return <EditTemplateProduct handleGoBack={handleGoBack}/>
}